// Budget amounts are $ thousands, as in the J-books.
export function fmtK(k: number | null | undefined, opts: { sign?: boolean } = {}): string {
  if (k === null || k === undefined || Number.isNaN(k)) return '—';
  const sign = k < 0 ? '−' : opts.sign && k > 0 ? '+' : '';
  const a = Math.abs(k);
  if (a >= 1_000_000) return `${sign}$${(a / 1_000_000).toFixed(a >= 10_000_000 ? 1 : 2)}B`;
  if (a >= 1_000) return `${sign}$${(a / 1_000).toFixed(a >= 100_000 ? 0 : 1)}M`;
  return `${sign}$${a.toLocaleString()}K`;
}

export function pct(from: number | null | undefined, to: number | null | undefined): number | null {
  if (from === null || from === undefined || to === null || to === undefined || from === 0) return null;
  return ((to - from) / Math.abs(from)) * 100;
}

export function fmtPct(p: number | null): string {
  if (p === null || !Number.isFinite(p)) return '';
  const r = Math.round(p);
  return `${r > 0 ? '+' : ''}${r}%`;
}

export const STAGE_LABEL: Record<string, string> = {
  actual: 'Actual', enacted: 'Enacted', cr: 'CR level', supplemental: 'Supplemental', total: 'Total', pb: 'Request',
  reconciliation: 'Reconciliation', mandatory: 'Mandatory', hac: 'HAC mark', sac: 'SAC mark', hasc: 'HASC mark', sasc: 'SASC mark',
  conference: 'Conference', reprogramming: 'Reprogramming', other: 'Other',
};
export const STAGE_ORDER = ['actual', 'cr', 'enacted', 'supplemental', 'reconciliation', 'mandatory', 'total', 'pb', 'hac', 'sac', 'hasc', 'sasc', 'conference', 'reprogramming', 'other'];
